import { createContext, useId } from 'react';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';

var BiomePortalIdContext = /*#__PURE__*/createContext(undefined);
function BiomePortalIdProvider(_ref) {
  var children = _ref.children;
  var id = useId().replaceAll(":", "-");
  return jsx(BiomePortalIdContext.Provider, {
    value: id,
    children: children
  });
}

export { BiomePortalIdContext as B, BiomePortalIdProvider as a };
//# sourceMappingURL=BiomePortalIdProvider.js.map
